<template>
    <el-tooltip v-if="componentShow" :disabled="tipdisable" class="item" effect="dark" :content="tipContent" placement="top">
        <el-select ref="zmCallTable" clearable filterable v-model="newValue" :allow-create="allowCreate" :name="name" :default-first-option="defaultFirstOption"
                   style="width: 100%;" :tabindex="tabindex" :multiple="multiple" :multiple-limit="multipleLimit" :disabled="disabled" :filter-method="calltableFilter"  @blur="selBlur"
                   :collapse-tags="collapseTags" :placeholder="placeholder" @change="selectChange" @visible-change="visibleChange">
            <el-option v-for="item in tablelist" :key="keyField ? item[keyField] : item[callValue]" :label="item[callLabel]" :value="item[callValue]">
                <span style="float: left">{{ item[callText] }}</span>
            </el-option>
        </el-select>
    </el-tooltip>
</template>

<script>
    export default {
        name: "CallTable",
        beforeCreate() {
		this.i18nPage = 'component.zmCallTable.';
	},
        props: {
            tableName:{
                type:String
            },
            value:{
                type:[String,Number,Array]
            },
            multiple:{
                type:Boolean,
                default:false
            },
            multipleLimit:{
                type:Number,
                default:0
            },
            allowCreate:{
                type:Boolean,
                default:false
            },
            disabled:{
                type:Boolean,
                default:false
            },
            collapseTags:{
                type:Boolean,
                default:false
            },
            tabindex:{
                type:String
            },
            placeholder:{
                type:String
            },
            defaultExtra:{
                type:[String,Number]
            },
            keyField:{
                type:String
            },
            filterFun:{
                type:Function
            },
            name:{
                type:String
            },
            defaultFirstOption:{
                type:Boolean,
                default:true
            },
            defaultQuery:{
                type:Boolean,
                default:true
            },
            isLocalData:{
                type:Boolean,
                default:false
            },
            localDataFun:Function,
            localLabel:String,
            localValue:String,
            blurClosePanel:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return {
                tipdisable:true,
                tipContent:'',
                tablelist:[],
                copyTableList:[],
                callValue:'',
                callLabel:'',
                callText:'',
                componentShow:true,
                initCount:0,
                i18nPage : 'component.zmCallTable.',
            }
        },
        computed:{
            newValue: {
                get:function() {
                    return this.value;
                },
                set:function(value) {
                    this.$emit('input', value);
                }
            }
        },
        methods: {
            setValue(val){
                if(val){
                    if(this.copyTableList && this.copyTableList.length > 0){
                        let valObj = this.copyTableList.find((item)=>{
                            return item[this.callValue] === val;
                        });
                        if(valObj){
                            this.newValue = val;
                            this.$emit('change',valObj);
                        }
                    }else{
                        let extra = this.defaultExtra ? this.defaultExtra : null;
                        this.$global.getTransferTable(this.tableName,extra).then(res => {
                            this.tablelist = res;
                            this.copyTableList = res;
                            let valObj = this.copyTableList.find((item)=>{
                                return item[this.callValue] === val;
                            });
                            if(valObj){
                                this.newValue = val;
                                this.$emit('change',valObj);
                            }
                            this.$emit('loadedsuccess',res);
                        });
                    }
                }
            },
            //获取列表数据
            getTableList(extra,val){
                if(this.isLocalData){
                    let localData = this.localDataFun();
                    this.callValue = this.localValue;
                    this.callLabel = this.localLabel;
                    this.callText =  this.localLabel;
                    this.tablelist = localData;
                    this.copyTableList = localData;
                    if(val){
                        this.newValue = val;
                    }
                    this.$emit('loadedsuccess',localData);
                }else{
                    if(this.tableName){
                        let callTableInfo = this.$util.get("callTableInfo");
                        if(callTableInfo){
                            if(callTableInfo[this.tableName]){
                                this.callValue = callTableInfo[this.tableName].value;
                                this.callLabel = callTableInfo[this.tableName].label;
                                // this.callText = callTableInfo[this.tableName].text || callTableInfo[this.tableName].label;
                                this.callText = callTableInfo[this.tableName].no ? 'text' : callTableInfo[this.tableName].label;
                                this.$global.getTransferTable(this.tableName,extra).then(res => {
                                    this.tablelist = res;
                                    this.copyTableList = res;
                                    if(val){
                                        this.newValue = val;
                                    }
                                    this.$emit('loadedsuccess',res);
                                });
                            }else{
                                this.$util.show(this.tableName+this.$t(this.i18nPage+"调用表信息不存在"),1);
                            }
                        }else{
                            if(this.initCount < 10){
                                setTimeout(() => {
                                    this.initCount ++;
                                    this.getTableList(extra,val);
                                },5000)
                            }else{
                                this.$util.show(this.$t(this.i18nPage+'调用表配置加载失败'),1)
                            }
                        }

                        // var callTableInfo = this.$global.getCallTableInfo();
                    }
                }
            },
            //返回选择对象或数组
            selectChange(val){
                //多选返回选择数据数组  单选返回选择对象
                if(this.multiple){
                    if(val && val.length > 0){
                        var returnArr = [];
                        this.copyTableList.forEach((item, index) => {
                            if(val.indexOf(item[this.callValue]) > -1){
                                returnArr.push(item);
                            }
                        });
                        if (this.multipleLimit != 0 && returnArr.length > this.multipleLimit) {
                            returnArr.slice(0,this.multipleLimit)
                        }
                        this.$emit('change',returnArr);
                    }else{
                        this.tipdisable = true;
                        this.$emit('change',[]);
                    }

                }else{
                    let obj = {};
                    obj = this.tablelist.find((item)=>{
                        return item[this.callValue] === val;
                    });
                    this.$emit('change',obj);
                }
            },
            //获取焦点
            focus(){
                this.$refs['zmCallTable'].focus();
            },
            //自定义过滤方法
            calltableFilter(val){
                if(this.filterFun){
                    this.filterFun(val,this.copyTableList);
                }else{
                    if (val) { //val存在
                        this.tablelist = this.copyTableList.filter((item) => {
                            if (item[this.callText].indexOf(val) > -1 || item[this.callText].toUpperCase().indexOf(val.toUpperCase()) > -1) {
                                return true
                            }
                        })
                    } else { //val为空时，还原数组
                        this.tablelist = this.copyTableList;
                    }
                }
            },
            //在列表展开的时候显示所有数据
            visibleChange(vc){
                if(vc){
                    this.tablelist = this.copyTableList;
                }
            },
            blur(event){
                this.$refs['zmCallTable'].blur();
            },
            selBlur(){
                if(this.blurClosePanel){
                    setTimeout(() => {
                        this.$refs['zmCallTable'].visible = false;
                    },100)
                }
            }
        },
        created(){
            if(this.defaultQuery){
                if(this.defaultExtra){
                    this.getTableList(this.defaultExtra);
                }else{
                    this.getTableList();
                }
            }
        },
        updated(){
            if(this.multiple){
                let content = '';
                if(this.newValue && this.newValue.length > 0){
                    this.copyTableList.forEach((item, index) => {
                        if(this.newValue.indexOf(item[this.callValue]) > -1){
                            if(content){
                                content += '，'+ item[this.callLabel];
                            }else{
                                content += item[this.callLabel]
                            }
                        }
                    });
                    this.tipContent = content;
                    let selectTag = this.$refs['zmCallTable'].$el.children[0];
                    if(selectTag.scrollHeight > selectTag.clientHeight){
                        this.tipdisable = false;
                    }else{
                        this.tipdisable = true;
                    }
                }else{
                    this.tipdisable = true;
                }
            }
        },
        beforeDestroy(){
            this.tablelist = [];
            this.copyTableList = [];
            this.componentShow = false;
        }
    };
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/CallTable/index.vue